enum BrandProfileAssetCategory {
    LOGO = 'logo',
    IMAGE = 'image',
    STYLE_GUIDE = 'style_guide',
    TEMPLATE = 'template',
    OTHER = 'other',
}

export default BrandProfileAssetCategory;
